import script from "./tutorSubscriptionPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorSubscriptionPlans.vue?vue&type=script&setup=true&lang=js"

import "./tutorSubscriptionPlans.vue?vue&type=style&index=0&id=b3e910e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3e910e8"]])

export default __exports__